import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, ShieldCheck, Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/lenis";

const LINKS = [
    { id: "manifeste", label: "Le Manifeste" },
    { id: "benefices", label: "Bénéfices" },
    { id: "anatomie", label: "Anatomie" },
    { id: "offres", label: "Offres" },
    { id: "avis", label: "Avis" },
    { id: "faq", label: "FAQ" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const go = (id) => {
        setOpen(false);
        setTimeout(() => scrollToId(id), open ? 150 : 0);
    };
    return (
        <header className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-xl border-b border-sage/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 lg:h-20 flex items-center justify-between gap-4">
                <button data-testid="header-logo" onClick={() => go("hero")} className="flex items-center gap-2 shrink-0">
                    <span className="w-8 h-8 rounded-full bg-sage text-cream grid place-items-center">
                        <Plus size={16} strokeWidth={2.5} />
                    </span>
                    <span className="font-serif text-2xl font-semibold tracking-tight text-ink">
                        Ergocox<span className="text-terra">™</span>
                    </span>
                </button>
                <nav className="hidden lg:flex items-center gap-7">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="text-sm font-medium text-ink/70 hover:text-sage transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <span className="hidden md:inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.15em] text-sage bg-sage-soft rounded-full px-3 py-1.5">
                        <ShieldCheck size={14} /> Recommandé par les Kinés
                    </span>
                    <button
                        data-testid="header-cta"
                        onClick={() => go("offres")}
                        className="hidden sm:inline-flex rounded-full bg-sage hover:bg-sage-hover text-cream text-sm font-semibold px-5 py-2.5 transition-all duration-300 hover:scale-[1.02] hover:shadow-lg shadow-sage/20"
                    >
                        Commander — 49,90 €
                    </button>
                    <button
                        data-testid="mobile-menu-button"
                        aria-label="Menu"
                        className="lg:hidden p-2 text-ink"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>
            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                        className="lg:hidden overflow-hidden border-t border-sage/10 bg-cream"
                    >
                        <div className="px-6 py-4 flex flex-col gap-1">
                            {LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    data-testid={`mobile-nav-link-${l.id}`}
                                    onClick={() => go(l.id)}
                                    className="text-left py-3 text-base font-medium text-ink border-b border-sage/5"
                                >
                                    {l.label}
                                </button>
                            ))}
                            <button
                                data-testid="mobile-header-cta"
                                onClick={() => go("offres")}
                                className="mt-3 mb-2 rounded-full bg-sage text-cream font-semibold px-5 py-3"
                            >
                                Commander — 49,90 €
                            </button>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
}
